<template>
  <div class="dashboard-page-wrapper">
    <a-row :gutter="12">
      <a-col :md="5" :lg="4" :xl="3">
        <div class="dashboard-sidebar">
          <DashboardHeader />
        </div>
      </a-col>
      <a-col :md="19" :lg="20" :xl="21">
        <div class="dashboard-content">
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import DashboardHeader from "@/components/dashboard/Header";

export default {
  name: "Dashboard",
  components: {
    DashboardHeader
  }
};
</script>

<style lang="less">
</style>